export default "__VITE_ASSET__CQnMZnzm__"